import Vue from "vue";
import { Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_SET_VALUE_BY_FIELD } from "../../store/reception/reception-types.store";
import { ActivityStatus, SearchEntities } from "../../common/enums";
import { IReceptionParameter } from "../../models/reception";
import { SEARCH_MODULE_NAMESPACE, SEARCH_AUTOCOMPLETE } from "../../store/search";

const ReceptionStore = namespace(RECEPTION_MODULE_NAMESPACE)
@Component({
  components: {
    'reception-sidebar': async () => import('./components/mh-reception-sidebar/MHReceptionSideBar.vue')
  }
})
class MHReceptionContainer extends Vue {


  @ReceptionStore.Getter receptionsSource: { activityStatus: ActivityStatus }
  @ReceptionStore.Getter receptionSource: { activityStatus: ActivityStatus }
  @ReceptionStore.Getter receptionParameter: IReceptionParameter;

  @ReceptionStore.Mutation(RECEPTION_SET_VALUE_BY_FIELD)
  storeAssignValueForReceptionParameter: (value: { [x: string]: any }) => void;

  /**
   *
   */
  constructor() {
    super();
  }

  get isLoading(): boolean {
    return this.receptionSource.activityStatus === ActivityStatus.Loading
      || this.receptionsSource.activityStatus === ActivityStatus.Loading
  }

  get lblSetting() {
    return {
      ...require('@/locales/reception').default
    }
  }

  get subNavTitle()
  {
    if(this.$route.path.includes('/vehicle-check'))
    {
      return 'Contrôle véhicule'//this.$t(this.lblSetting.receptionTitle)
    } else {
      return this.$t(this.lblSetting.receptionTitle)
    }
  }

  get coKeyword(): string {
    return JSON.parse(JSON.stringify(this.receptionParameter)).key;
  }
  set coKeyword(val: string) {
    this.storeAssignValueForReceptionParameter({ key: val })
  }
  get searchVisible(): boolean {
    return this.$route.params.id === undefined
  }
  created() { }
  mounted() {
  }

  handleEditReceptions(){

  }
}

export default MHReceptionContainer



// WEBPACK FOOTER //
// ./src/containers/mh-reception/index.ts